// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const menuClasses = {
  button: "qui-menu__button",
  content: "qui-menu__content",
  indicator: "qui-menu__indicator",
  separator: "qui-menu__separator",
  splitButton: "qui-menu__split-button",
} as const
